import React from "react";
import { Link } from "react-router-dom";
import "./ChallengeHeroBanner.css";

// Public homepage promo card for the TutorsLinks Educator Impact Challenge
// 2026 → /award. Replaces the old Abiri Support hero card; that initiative
// stays reachable via the small secondary link below the CTA.
const ChallengeHeroBanner = () => {
  return (
    <div className="challenge-hero-banner">
      <Link
        to="/award"
        className="challenge-hero-banner-link"
        aria-label="TutorsLinks Educator Impact Challenge 2026 — apply now"
      >
        <span className="challenge-hero-banner-shine" aria-hidden="true" />
        <div className="challenge-hero-banner-inner">
          <span className="challenge-hero-banner-eyebrow">
            🏆 TutorsLinks Educator Impact Challenge 2026
          </span>
          <h3 className="challenge-hero-banner-title">
            ₦1,000,000 in Cash Prizes — 10 Winners of ₦100,000 Each
          </h3>
          <p className="challenge-hero-banner-sub">
            Teach us something useful in 3 minutes and stand a chance to win.
          </p>
          <span className="challenge-hero-banner-cta">Apply Now →</span>
        </div>
      </Link>
      {/* <Link to="/abiri-support" className="challenge-hero-banner-secondary-link">
        Also: The Royal Abiri of Ile-Ife JAMB UTME Support 2027 →
      </Link> */}
    </div>
  );
};

export default ChallengeHeroBanner;
